var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachFileSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.44,
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8764 1.44204C9.3808 -0.0535977 6.94717 -0.0535977 5.45134 1.44204L0.801149 6.09221C-0.267108 7.16058 -0.267038 8.89892 0.80129 9.96722C1.3355 10.5014 2.03699 10.7685 2.73875 10.7685C3.44033 10.7684 4.14219 10.5014 4.67631 9.96722L8.93884 5.70457C9.24938 5.39407 9.42043 4.98122 9.42048 4.5421C9.42048 4.10295 9.2495 3.69012 8.93891 3.37953C8.29785 2.73854 7.25478 2.73856 6.61386 3.37965L3.82632 6.16711C3.61231 6.3811 3.61231 6.72809 3.82627 6.94212C4.04026 7.15618 4.38725 7.15611 4.60128 6.94212L7.38884 4.15463C7.60252 3.94095 7.95015 3.9409 8.16385 4.15458C8.26735 4.25808 8.32438 4.39571 8.32438 4.54207C8.32438 4.68844 8.26738 4.82602 8.16385 4.92957L3.9013 9.19219C3.26026 9.83316 2.21729 9.83325 1.5763 9.19224C0.935306 8.5512 0.935259 7.50818 1.57618 6.86714L6.22635 2.21705C7.29477 1.14868 9.0331 1.14868 10.1014 2.21705C10.6189 2.73455 10.904 3.42265 10.904 4.15454C10.904 4.88642 10.6189 5.57452 10.1014 6.09207L5.45127 10.7423C5.23728 10.9563 5.23728 11.3033 5.45131 11.5173C5.55833 11.6243 5.69858 11.6778 5.83881 11.6778C5.97906 11.6778 6.11931 11.6243 6.22632 11.5173L10.8763 6.8671C11.6009 6.14257 12 5.17925 12 4.15456C12 3.12989 11.6009 2.16657 10.8764 1.44204Z",
    fill: "#00071A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachFileSmall);
export default __webpack_public_path__ + "static/media/attachFile--small.21496cd148f427a10f81c0d8b12c8e41.svg";
export { ForwardRef as ReactComponent };